import React from 'react';

export const SilverContent = (): JSX.Element => {
  return (
    <div className="py-4">
      <div className="text-s-28 font-bold sm:text-s-20">
        Silver System in India
      </div>
      <div className="py-5">
        <p className="text-base">
          Gold is not all that glitter. Silver might not be as expensive as
          gold, but its demand is no less. Some even call it &apos;gold of the
          poor&apos;. Considered highly auspicious, it is common for many Indian
          households to use silverware and even gift them to loved ones on
          festive occasions. Not to mention, silver jewellery are timeless and
          it is here to stay. Silver rates in India (like gold) is subject to
          market change. In this article, we will explore this topic in detail.
        </p>
        <ol>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              1. Silver Rate in India
            </strong>{' '}
            <br />
            Many an investor keep a close eye on the fluctuating silver rates.
            It helps them to invest at the right time and also study the market
            fairly accurately. Silver rates in India are dependent on factors
            like inflation, supply and occasion among others.
          </li>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              2. How to invest in Silver?
            </strong>
            <br />
            Silver is more suited for long-term investors as it is an
            appreciatory commodity and takes time for price appreciation. There
            are many ways to invest in silver - choose one based on your
            investment needs.
            <br /> <br />
            <strong>Silver bars or coins (bullions)</strong> - You can buy coin
            or bar from any authorized store or even from a bank. This way, you
            save on making charges.
            <br />
            <br />
            <strong> Silver jewellery and ornaments</strong> - Silver ornaments
            are as favored by Indians as gold. However, you must always go for
            sterling silver with the 925 hallmark. This indicates that the
            silver is 92.5% pure.
            <br />
            <br />
            <strong> Silver stocks</strong> - This is a popular way of investing
            as silver is a reliable long-term investment that can act as a hedge
            in volatile markets. The price to be pais is as per that day&apos;s
            silver rate in the city.
            <br />
            <br />
            <strong> E-silver</strong> - Electronic silver or e-silver solves
            the storage issue of physical silver. You can directly trade them on
            NSEL (National Spot Exchange Limited).
          </li>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              3. Factors Affecting Silver Price in India
            </strong>{' '}
            <br />
            <strong>Less Supply and More Demand</strong> - Use of silver has
            increased manifold in India. Many consider it auspicious and hence
            the demand will never go down. Due to limited supply, it will remain
            expensive. Things like a strike in the mining field or production
            company or finding a new use for it can also surge the price.
            <br />
            <br />
            <strong>Technology and electronic trends</strong> - Many electronic
            goods and latest technology find silver irreplaceable and this
            impacts its cost. As the IT hub and Silicon Valley of India, this is
            particularly true for India.
            <br />
            <br />
            <strong>Inflation</strong> - Similarly, if income becomes less, so
            will the expenditures and hence the purchase of silver (among
            others). However, investors see silver as an investment that acts as
            a hedge against inflation. So, even as currency value drops, silver
            assures protection against losses in purchasing power.
            <br />
            <br />
            <strong>Gold Prices</strong> - Yes, as surprising it is, gold prices
            do affect silver prices. Simply put, silver always follow gold when
            it comes price hikes or drops.
            <br />
            <br />
            <strong>Interest Rates</strong> - Base interest rate is an indicator
            of general market conditions. Since silver investments aim for
            long-term appreciation rather than current returns, market prices
            usually have an inverse association with the changing rates.
            <br />
            <br />
            <strong>Government and RBI Guidelines</strong> - As a popular
            precious metal, silver prices depend on changing policies and
            actions. For instance, while gold is used as the reserve, many
            central banks across the world transact silver bullion.
            <br />
            <br />
            <strong>Crude prices</strong> - Silver mining is an intense process
            that requires high energy. Hence, its price relies on the oil
            prices. Volatility in one sector certainly pulls down the other.
          </li>
          <li className="text-base text-font-200 font-medium py-3">
            <strong className="text-font-500 text-s-18">
              4. Silver Purity
            </strong>{' '}
            <br /> You can find silver of different grades and purities. They
            are generally categorized as below. Fine Silver - 99.9% silver
            mostly used for industrial applications. It is not used for
            jewellery-making. Sterling Silver - This is the 925 hallmark silver
            every silver ornament lover knows about. For jewellery, this is the
            purest and most malleable
          </li>
        </ol>
      </div>
    </div>
  );
};
